(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResourceDetailController', ResourceDetailController);

    ResourceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Resource', 'Round', 'ResourceKey'];

    function ResourceDetailController($scope, $rootScope, $stateParams, entity, Resource, Round, ResourceKey) {
        var vm = this;

        vm.resource = entity;

        var unsubscribe = $rootScope.$on('portalApp:resourceUpdate', function(event, result) {
            vm.resource = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
